import { SHOW_ALERT_MSG } from './actionTypes';


export const showAlertMessage = (config) => {
    return {
        type: SHOW_ALERT_MSG,
        config
    };
}